define(["exports", "react"], function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = useHover;

  function useHover(ref) {
    var _useState = (0, _react.useState)(false),
        value = _useState[0],
        setValue = _useState[1];

    (0, _react.useEffect)(function () {
      var handleMouseOver = function handleMouseOver() {
        return setValue(true);
      };

      var handleMouseOut = function handleMouseOut() {
        return setValue(false);
      };

      var node = ref.current;

      if (node) {
        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseout', handleMouseOut);
        return function () {
          node.removeEventListener('mouseover', handleMouseOver);
          node.removeEventListener('mouseout', handleMouseOut);
        };
      }
    }, [ref]);
    return value;
  }
});